module.exports = __webpack_public_path__ + "static/img/zheshu9.35f0385e.png";